import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'price-preferences',
  templateUrl: './price-preferences.html',
  styleUrls: ['./price-preferences.scss'],
  standalone: false,
})
export class PricePreferencesComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  @Input() settings: CheckoutSettings;
  constructor() {}
}
